
import Input from '../../../../../Core/Fields/Floating/Input';
import Date from '../../../../../Core/Fields/Floating/Date';


const GeneralDetailsTab1 = ({ formData, onFieldChange }) => {

    return (
        <div>
            <div className="px-2 py-3" style={{ background: 'white' }}>
                <div style={{ display: 'flex' }} >
                    <div className="col-md-6 px-2">
                        <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                        <p className='m-0' style={{fontSize:'16px',fontWeight:'600'}}>Details</p>
                                    </div>
                                </div>
                                    
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <Input label="No." style={{ height: "30px" }} value={formData.series} onChange={(e) => onFieldChange('series', e.target.value)} />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <Date label="Date" style={{ height: "30px" }} value={formData.date_of_visit} onChange={(e) => onFieldChange('date_of_visit', e.target.value)} />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <Input label="Sales Order No." style={{ height: "30px" }} value={formData.customer} onChange={(e) => onFieldChange('customer', e.target.value)} />
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                 <div style={{ flex: 1 }}>
                                    <Input label="Customer No." style={{ height: "30px" }} value={formData.customer} onChange={(e) => onFieldChange('customer', e.target.value)} />
                                </div>
                                 <div style={{ flex: 1 }}>
                                    <Date label="Delivery Date" style={{ height: "30px" }} value={formData.date_of_visit} onChange={(e) => onFieldChange('date_of_visit', e.target.value)} />
                                </div>
                                 <div style={{ flex: 1 }}>
                                </div>                                                           
                            </div>
                           
                        </div>
                    </div>

                    <div className="col-md-6 px-2">
                        <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                           <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                        <p className='m-0' style={{fontSize:'16px',fontWeight:'600',visibility:'hidden'}}>.</p>
                                    </div>
                                </div>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <Input label="Billing Type" style={{ height: "30px" }} value={formData.customer} onChange={(e) => onFieldChange('customer', e.target.value)} />
                                </div>
                                 <div style={{ flex: 1 }}>
                                    <Input label="Order Type " style={{ height: "30px" }} value={formData.date_of_visit} onChange={(e) => onFieldChange('date_of_visit', e.target.value)} />
                                </div>                              
                            </div>

                            <div style={{ display: 'flex', gap: '15px' }}>
                                 <div style={{ flex: 1 }}>
                                    <Input label="Purpose" style={{ height: "30px" }} value={formData.date_of_visit} onChange={(e) => onFieldChange('date_of_visit', e.target.value)} />
                                </div>                             
                                <div style={{ flex: 1 }}>
                                    <Input label="Assigned To" style={{ height: "30px" }} value={formData.date_of_visit} onChange={(e) => onFieldChange('date_of_visit', e.target.value)} />
                                </div> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
   
        </div>
    );
};

export default GeneralDetailsTab1;



